<script>
import ErpSField from "@/plugins/uloc-erp/components/form/SimpleField"
import ErpInput from "@/plugins/uloc-erp/components/form/input"
import ERow from "components/layout/components/Row.vue"
import ECol from "components/layout/components/Col.vue"
import {find} from "@/domain/usuario/services"
import {update, aceitaTermos} from "@/domain/usuario/services/updater"
import {UCheckbox} from "uloc-vue"

export default {
  name: 'SoftwareUpdater',
  components: {
    ECol,
    ERow,
    ErpInput,
    ErpSField,
    UCheckbox
  },
  mounted() {
    this.load()
  },
  data () {
    return {
      mounted: false,
      loading: false,
      user: null,
      cadastro: {
        name: null,
        document: null,
        email: null,
        phoneNumber: null
      },
      termos: {
        aceite: false
      },
      etapa: 'cadastro'
    }
  },
  methods: {
    load () {
      find(this.$uloc.auth.session.user.id)
          .then(response => {
            this.user = response.data
            this.cadastro.name = response.data.person.name
            this.cadastro.document = response.data.person.document
            this.cadastro.email = response.data.email
            this.cadastro.phoneNumber = Array.isArray(response.data.person.phoneNumbers) && response.data.person.phoneNumbers.length > 0
                ? response.data.person.phoneNumbers[0].phoneNumber
                : null;
            this.$nextTick(() => {
              this.mounted = true
            })
          })
          .catch(error => {
            this.alertApiError(error)
          })
    },
    atualizaCadastro () {
      this.loading = true
      update(this.user.id, this.cadastro)
          .then(response => {
            this.loading = false
            this.etapa = 'termos'
            console.log(response.data)
          })
          .catch(error => {
            this.loading = false
            this.alertApiError(error)
          })
    },
    aceitarTermos () {
      this.loading = true
      aceitaTermos()
          .then(response => {
            this.loading = false
            console.log(response.data)
            this.$uloc.notify({color: 'positive', position: 'top-right', message: 'Obrigado por concordar com nossos termos e políticas.'})
            this.$router.push('/')
          })
          .catch(error => {
            this.loading = false
            this.alertApiError(error)
          })
    }
  }
}
</script>

<template>
  <div v-if="mounted" class="software-updater">
<!--    <div class="sheader">

    </div>-->
    <div v-if="etapa === 'cadastro'" class="smain-page">
      <div class="smain">
        <vue-typed-js :typeSpeed="5" :startDelay="100" class="hideCursor"
                      :strings="['Olá!']">
          <h3 class="typing">
          </h3>
        </vue-typed-js>
        <vue-typed-js :typeSpeed="2" :startDelay="200" class="hideCursor"
                      :strings="['A Suporte Leilões está <strong>passando por grandes mudanças</strong>, e parte deste processo precisamos confirmar algumas informações e atualizar seu cadastro.']">
          <div class="typing">
          </div>
        </vue-typed-js>

        <div class="sform e-input-modern">
          <e-row class="m-t-lg" mr>
            <e-col>
              <erp-s-field label="Seu nome completo está correto?">
                <erp-input v-model="cadastro.name" autofocus />
              </erp-s-field>
            </e-col>
            <e-col>
              <erp-s-field label="Confirme seu CPF">
                <erp-input v-model="cadastro.document" v-mask="'###.###.###-##'" />
              </erp-s-field>
            </e-col>
            <e-col></e-col>
          </e-row>
          <e-row class="m-t" mr>
            <e-col>A partir do dia <u>2 de junho de 2025</u> será obrigatório a autenticação de dois fatores ao acessar o ERP de um IP desconhecido, por isso, precisamos que seu e-mail seja válido e acessível por você, pois ao logar de um novo IP, iremos enviar um código de confirmação por e-mail ou SMS para validar seu acesso ao software.</e-col>
          </e-row>
          <e-row class="m-t" mr>
            <e-col>
              <erp-s-field label="Confirme seu e-mail">
                <erp-input v-model="cadastro.email" />
              </erp-s-field>
            </e-col>
            <e-col></e-col>
          </e-row>
          <e-row class="m-t" mr>
            <e-col>
              <erp-s-field label="Confirme seu telefone celular">
                <erp-input v-model="cadastro.phoneNumber" v-mask="'(##) # ####-####'" placeholder="(00) 9 0000-0000" />
              </erp-s-field>
            </e-col>
            <e-col></e-col>
          </e-row>
        </div>
      </div>
      <div class="smain-btn">
        <u-btn class="sl-btn" color="blue" no-caps label="Atualizar meu cadastro" @click="atualizaCadastro" :loading="loading" />
      </div>
    </div>

    <div v-if="etapa === 'termos'" class="smain-page">
      <div class="smain">

        <div class="header-desc m-b-lg"><i class="ico fa fa-duotone fa-file-signature"></i>
          <div>Nossos Termos de Uso e Política de Atendimento e Suporte foram atualizados. Você precisa lê-los e aceitá-los para continuar</div>
        </div>

        <div class="smain border">
<!--          <div class="header-desc">
            <i class="ico fa fa-duotone fa-file-signature"></i>
            <div>Termos de Uso</div>
          </div>-->
          <iframe
              src="https://docs.suporteleiloes.com/politicas/termos-de-uso/"
              width="100%"
              height="600"
              style="border: none;"
          ></iframe>
        </div>

        <div class="smain border m-t">
<!--          <div class="header-desc">
            <i class="ico fa fa-duotone fa-file-signature"></i>
            <div>Nossa nova política de atendimento</div>
          </div>-->
          <iframe
              src="https://docs.suporteleiloes.com/politicas/atendimento/"
              width="100%"
              height="600"
              style="border: none;"
          ></iframe>
        </div>

        <div class="smain border m-t">
          <div class="flex items-center">
            <u-checkbox v-model="termos.aceite" />
            <div class="m-l-xs font-14 font-bold">
              Declaro que li e estou de acordo com os Termos de Uso e a Política de Atendimento da plataforma.
            </div>
          </div>
        </div>
      </div>
      <div class="smain-btn">
        <u-btn class="sl-btn" color="blue" no-caps label="Aceitar termos e continuar" @click="aceitarTermos" :disable="!termos.aceite" :loading="loading" />
      </div>
    </div>
  </div>
</template>

<style lang="stylus" src="./assets/default.styl"></style>
